import { observable } from 'mobx';

export class SnackbarStore {
  @observable
  snackbarMessages = [] as string[];
}
